module.exports = __webpack_public_path__ + "img/kh2@2x.a1b4cae1.png";